<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="defaultHref" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title [innerHTML]="(surveyField$| async)?.question"></ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="survey-field">
  <div class="white-wrapper">
    <div class="survey-field__header">
      <span class="survey-field__title" [innerHTML]="(surveyField$| async)?.question"></span>
      <ion-icon class="survey-field__ellipsis" slot="icon-only" name="ellipsis-vertical" (click)="presentGeneralPopover($event)"></ion-icon>
    </div>
    <div class="survey-field__content">
      <div class="survey-field__content__image">
        <img [src]="(surveyField$ | async)?.imageUrl" />
      </div>
      <div
        class="survey-field__content__description"
        [class.--is-empty]="!(surveyField$| async)?.description"
        [innerHTML]="(surveyField$| async)?.description ||('ADMIN_SURVEYS.NO_DESCRIPTION' | translate)"
      ></div>
    </div>
  </div>
</ion-content>
